/**
 * Created by 艺术家 on 2017/7/13.
 * 正则表达式工具类
 */

const $ = {}

/**
 * 验证是否是合法的电子邮箱。
 * @param {String} value
 * @return {Boolean}
 */
$.isEmail = function(value) {
  if (value === '') return false
  const reg = /^[0-9a-z][_.0-9a-z-]{0,31}@([0-9a-z][0-9a-z-]{0,30}[0-9a-z]\.){1,4}[a-z]{2,4}$/
  return reg.test(value)
}

/**
 * 验证是否是合法的手机号码。
 * @param {String} value
 * @return {Boolean}
 */
$.isMobilephone = function(value) {
  if (value === '') return false
  const reg = /^[1]\d{10}$/
  return reg.test(value)
}

/**
 * 验证是否是合法的QQ号。
 * @param {String} value
 * @return {Boolean}
 */
$.isQQ = function(value) {
  if (value === '') return false
  const reg = /^\d{5,10}$/
  return reg.test(value)
}

/**
 * 验证是否是合法的微信号。
 * @param {String} value
 * @return {Boolean}
 */
$.isWechat = function(value) {
  if (value === '') return false
  const reg = /^[a-zA-Z]{1}[-_a-zA-Z\d]{5,19}$/
  return reg.test(value)
}

/**
 * 验证是否是数字。
 * @param {String} value
 * @return {Boolean}
 */
$.IsNumeric = function(value) {
  if (value === '') return false
  var reg = /^[+-]?\d*[.]?\d*$/
  return reg.test(value)
}

/**
 * 验证是否是整数。
 * @param {String} value
 * @return {Boolean}
 */
$.IsInt = function(value) {
  if (value === '') return false
  var reg = /^[+-]?\d*$/
  return reg.test(value)
}

/**
 * 验证是否是合法的18位身份证号。
 * @param {String} value
 * @return {Boolean}
 */
$.IsIDNumber = function(value) {
  var p = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
  var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
  var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
  var code = value.substring(17);
  if (p.test(value)) {
    var sum = 0;
    for (var i = 0; i < 17; i++) {
      sum += value[i] * factor[i];
    }
    if (parity[sum % 11 ].toString() === code.toUpperCase()) {
      return true;
    }
  }
  return false;
}

/**
 * 检查银行卡号
 * @param {String} value
 * @return {Boolean}
 */
$.IsBankNo = function(value) {
  return checkBankNo(value);
}

/**
 * 检查银行卡号是否符合规则
 * @param bankno 银行卡号
 * @returns
 */
function checkBankNo(bankno) {
  bankno = bankno.replace(/\s/g, '');
  if (bankno === '') {
    console.log('checkBankNo> 01 请填写银行卡号');
    return false;
  }
  if (bankno.length < 16 || bankno.length > 19) {
    console.log('checkBankNo> 02 银行卡号长度必须在16到19之间');
    return false;
  } else {
    console.log('checkBankNo> 02 银行卡号长度为', bankno.length);
  }
  var num = /^\d*$/;// 全数字
  if (!num.exec(bankno)) {
    console.log('checkBankNo> 03 银行卡号必须全为数字');
    return false;
  }
  // 开头两位
  var strBin = '10,18,30,35,37,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,58,60,62,65,68,69,84,87,88,94,95,98,99';
  if (strBin.indexOf(bankno.substring(0, 2)) === -1) {
    console.log('checkBankNo> 04 银行卡号开头两位不符合规范');
    return false;
  }
  // luhn校验
  if (!luhnCheck(bankno)) {
    return false;
  }
  return true;
}

/**
* 银行卡号luhn校验算法
* luhn校验规则：16位银行卡号（19位通用）:
* 1.将未带校验位的 15（或18）位卡号从右依次编号 1 到 15（18），位于奇数位号上的数字乘以 2。
* 2.将奇位乘积的个十位全部相加，再加上所有偶数位上的数字。
* 3.将加法和加上校验位能被 10 整除。
* @param bankno 银行卡号
* @returns
*/
function luhnCheck(bankno) {
  var lastNum = parseInt(bankno.substr(bankno.length - 1, 1));// 取出最后一位（与luhn进行比较）
  var first15Num = bankno.substr(0, bankno.length - 1);// 前15或18位
  var newArr = [];
  for (var i = first15Num.length - 1; i > -1; i--) { // 前15或18位倒序存进数组
    newArr.push(first15Num.substr(i, 1));
  }
  var arrJiShu = []; // 奇数位*2的积 <9
  var arrJiShu2 = []; // 奇数位*2的积 >9
  var arrOuShu = []; // 偶数位数组
  for (var j = 0; j < newArr.length; j++) {
    if ((j + 1) % 2 === 1) { // 奇数位
      if (parseInt(newArr[j]) * 2 < 9) {
        arrJiShu.push(parseInt(newArr[j]) * 2);
      } else {
        arrJiShu2.push(parseInt(newArr[j]) * 2);
      }
    } else {
      arrOuShu.push(newArr[j]);// 偶数位
    }
  }

  var jishu_child1 = [];// 奇数位*2 >9 的分割之后的数组个位数
  var jishu_child2 = [];// 奇数位*2 >9 的分割之后的数组十位数
  for (var h = 0; h < arrJiShu2.length; h++) {
    jishu_child1.push(parseInt(arrJiShu2[h]) % 10);
    jishu_child2.push(parseInt(arrJiShu2[h]) / 10);
  }
  var sumJiShu = 0; // 奇数位*2 < 9 的数组之和
  var sumOuShu = 0; // 偶数位数组之和
  var sumJiShuChild1 = 0; // 奇数位*2 >9 的分割之后的数组个位数之和
  var sumJiShuChild2 = 0; // 奇数位*2 >9 的分割之后的数组十位数之和
  var sumTotal = 0;
  for (var m = 0; m < arrJiShu.length; m++) {
    sumJiShu = sumJiShu + parseInt(arrJiShu[m]);
  }
  for (var n = 0; n < arrOuShu.length; n++) {
    sumOuShu = sumOuShu + parseInt(arrOuShu[n]);
  }
  for (var p = 0; p < jishu_child1.length; p++) {
    sumJiShuChild1 = sumJiShuChild1 + parseInt(jishu_child1[p]);
    sumJiShuChild2 = sumJiShuChild2 + parseInt(jishu_child2[p]);
  }
  // 计算总和
  sumTotal = parseInt(sumJiShu) + parseInt(sumOuShu) +
          parseInt(sumJiShuChild1) + parseInt(sumJiShuChild2);
  // 计算luhn值
  var k = parseInt(sumTotal) % 10 === 0 ? 10 : parseInt(sumTotal) % 10;
  var luhn = 10 - k;
  if (lastNum === luhn) {
    return true;
  } else {
    console.log('checkBankNo> 05 银行卡号必须符合luhn校验');
    return false;
  }
}

/**
 * 返回URL的各个部分。
 * @param {String} url
 * @return {Array}
 */
$.getUrl = function(url) {
  // 返回的数组一共包含8个部分：
  // 0 - 完整的url
  // 1 - 协议
  // 2 - 域名
  // 3 - 端口
  // 4 - 资源路径
  // 5 - 资源名
  // 6 - （未知）
  // 7 - 查询字符串与锚点
  /* eslint-disable no-useless-escape */
  return url.match(/(\w+):\/\/([^\:|\/]+)(\:\d*)?(.*\/)([^#|\?|\n]+)?(#.*)?(\?.*)?/i)
}

export default $
